import { render } from "./App.vue?vue&type=template&id=e72d8a32&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=e72d8a32&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e72d8a32"

export default script